// Sales: one-off orders and revenue (the Orders tab, pages/Orders.js), draft
// orders the assistant wrote down, plus wholesale trade: the businesses being
// sold to, their invoices and the trade price list. The open tab lives in the
// URL (?tab=trade) so a reload keeps it.
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import OrdersDashboard from './Orders';
import TradeSection from '../components/TradeSection';
import OrderDrafts from '../components/OrderDrafts';
import { useTradeData } from '../lib/useTradeData';
import { invoiceStats, pipelineStats, todayYmd } from '../lib/trade';

const TAB_KEYS = ['orders', 'drafts', 'trade', 'invoices', 'prices'];

export default function SalesPage() {
  const [params, setParams] = useSearchParams();
  const tab = TAB_KEYS.includes(params.get('tab')) ? params.get('tab') : 'orders';
  const setTab = useCallback(
    (t) => setParams(t === 'orders' ? {} : { tab: t }, { replace: true }),
    [setParams],
  );

  const trade = useTradeData();
  const today = todayYmd();
  const ready = trade.status === 'ready';
  const due = ready ? pipelineStats(trade.accounts, trade.invoices, today).dueFollowUps : 0;
  const overdue = ready ? invoiceStats(trade.invoices, today).overdueCount : 0;

  const header = {
    tabs: [
      { key: 'orders', label: 'Orders' },
      { key: 'drafts', label: 'Draft orders', title: 'Orders written down but not placed' },
      { divider: true },
      { key: 'trade', label: 'Trade', count: due, title: due ? `${due} follow-up${due === 1 ? '' : 's'} due` : 'Businesses you sell to wholesale' },
      { key: 'invoices', label: 'Invoices', count: overdue, title: overdue ? `${overdue} overdue` : 'Trade invoices' },
      { key: 'prices', label: 'Trade prices' },
    ],
    activeTab: tab,
    onTabChange: setTab,
  };

  if (tab === 'orders') return <OrdersDashboard header={header} />;
  if (tab === 'drafts') return <OrderDrafts header={header} />;
  return <TradeSection tab={tab} setTab={setTab} header={header} trade={trade} today={today} />;
}
